import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskedDateFormatter'
})
export class MaskedDateFormatterPipe implements PipeTransform {

  transform(value: any): any {
    if (value || value.includes('*')) {
      let splittedValue = value.split('-');
      var joinedDate = splittedValue.reverse().join("/");
      return joinedDate;
    }
  }


}
